module.exports = __webpack_public_path__ + "static/img/direct323.cba641c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/direct323.jpg
// module id = rlSe
// module chunks = 3